// import React, { useEffect, useState } from 'react';
// import '../RelatedProducts/RelatedProducts.css';
// import Item from '../Item/Item';
// import placeholder from '../Assets/Frontend_Assets/placeholder.jpg'
// const RelatedProducts = ({ productId }) => {
//   const [related, setRelated] = useState([]);

//   useEffect(() => {
//     if (!productId) return;
//     fetch(`${BASE_URL}/product/${productId}/related`)
//       .then(r => r.json())
//       .then(res => {
//         if (res.success) setRelated(res.related);
//       })
//       .catch(err => console.error(err));
//   }, [productId]);

//   if (related.length === 0) return null;

//   return (
//     <div className='relatedproducts'>
//       <h1>Related Products</h1>
//       <hr />
//       <div className="relatedproducts-item">
//         {related.map((item, i) => (
//           // <Item
//           //   key={i}
//           //   id={item.id}
//           //   product_name={item.product_name}
//           //   image={item.image}
//           //   new_price={item.new_price}
//           //   old_price={item.old_price}
//           //   material={item.material}
//           //   color={item.color}
//           // />
//            <Item
//               key={item.product_id}
//               id={item.product_id}
//               image={item.image || placeholder}
//               product_name={item.product_name}
//               productCode={item.product_code}
//               pieces={item.pieces?.length ? `${item.pieces.length} Piece` : ""}
//               clothType={item.cloth_type}
//               type={item.type?.toUpperCase()}
//               isNew={item.is_new}
//               new_price={item.new_price}
//               old_price={item.old_price}
//             />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default RelatedProducts;
import React, { useEffect, useState, useRef } from "react";
import "../RelatedProducts/RelatedProducts.css";
import Item from "../Item/Item";
import placeholder from "../Assets/Frontend_Assets/placeholder.jpg";
import BASE_URL from '../../Config/api';
const RelatedProducts = ({ productId }) => {
  const [related, setRelated] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    if (!productId) return;
    fetch(`${BASE_URL}/product/${productId}/related`)
      .then(r => r.json())
      .then(res => {
        if (res.success) setRelated(res.related);
      })
      .catch(err => console.error(err));
  }, [productId]);

  const slideNext = () => {
    const slider = sliderRef.current;
    const cardWidth = slider.firstChild.offsetWidth + 20; // item width + gap
    slider.scrollBy({ left: cardWidth, behavior: "smooth" });
  };

  const slidePrev = () => {
    const slider = sliderRef.current;
    const cardWidth = slider.firstChild.offsetWidth + 20;
    slider.scrollBy({ left: -cardWidth, behavior: "smooth" });
  };

  if (related.length === 0) return null;

  return (
    <div className="relatedproducts">
      <h1 style={{textAlign:"center"}}>Related Products</h1>
      
      
      <div className="slider-container">
        
        <button className="slider-btn left" onClick={slidePrev}>
          &lt;
        </button>
        <div className="relatedproducts-item" ref={sliderRef}>
          {related.map(item => (
            <Item
              key={item.product_id}
              id={item.product_id}
              image={item.image || placeholder}
              product_name={item.product_name}
              productCode={item.product_code}
              pieces={item.pieces?.length ? `${item.pieces.length} Piece` : ""}
              clothType={item.cloth_type}
              type={item.type?.toUpperCase()}
              isNew={item.is_new}
              new_price={item.new_price}
              old_price={item.old_price}
            />
          ))}
        </div>
        <button className="slider-btn right" onClick={slideNext}>
          &gt;
        </button>
      </div>
    </div>
  );
};

export default RelatedProducts;
